import * as React from 'react';

const Save = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12.6 6.4V16.38L8.78 13.83L8 13.31L7.22 13.83L3.4 16.38V6.4H12.6ZM14 5H2V19L8 15L14 19V5Z"
            fill="currentColor"
        />
    </svg>
);

export default Save;
